import { render, staticRenderFns } from "./books.vue?vue&type=template&id=d19e31e8&"
import script from "./books.vue?vue&type=script&lang=js&"
export * from "./books.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports